export const Logo = ({ className = "", subtitle, dark = false, testId = "carrano-logo" }) => (
  <div className={className} data-testid={testId}>
    <span
      className={`block font-bold uppercase leading-none ${dark ? "text-black" : "text-[#2B2118]"}`}
      style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", letterSpacing: "0.18em" }}
    >
      CARRANO
    </span>
    {subtitle && (
      <span className={`block text-[10px] uppercase mt-1.5 ${dark ? "text-black" : "text-[#8C7B68]"}`}
        style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", letterSpacing: "0.3em" }}>
        {subtitle}
      </span>
    )}
  </div>
);
